package com.rosario.juridico.domain

import kotlinx.datetime.LocalDate

data class SmvmItem(
    val periodo: String, // Formato YYYY-MM
    val smvm: Double,
    val esOficial: Boolean = true
)

data class PagoParcial(
    val id: String = "",
    val fecha: LocalDate,
    val monto: Double,
    val observacion: String = ""
)

data class RenglonCalculoSMVM(
    val periodo: String,
    val smvm: Double,
    val porcentaje: Double,
    val cuotaCalculada: Double,
    val pagosEfectuados: Double,
    val interes: Double,
    val saldo: Double,
    val esEstimado: Boolean
)

data class ResultadoCalculoSMVM(
    val renglones: List<RenglonCalculoSMVM>,
    val deudaTotal: Double,
    val subtotalCuotas: Double,
    val subtotalPagos: Double,
    val honorarios: Double
)
